<div class="ipm-dsi" [class.is-closing]="isClosing" role="dialog" aria-modal="true" aria-label="Beat22 Diwali Sale is live">
    <canvas class="ipm-dsi-bg" #bgCanvas aria-hidden="true"></canvas>
    <canvas class="ipm-dsi-fg" #fgCanvas aria-hidden="true"></canvas>

    <div class="ipm-dsi-stage">
        <img class="ipm-dsi-beat22" [class.in]="step >= 2" src="assets/imgs/beat22-logo/main-logo-beat22.svg" alt="Beat22">
        <div class="ipm-dsi-diwali" #diwaliLogo [class.in]="step >= 3">
            <span class="ipm-dsi-diwali-text">Diwali Sale</span><span class="ipm-dsi-diya" aria-hidden="true">🪔</span>
        </div>

        <!-- offer: by role (guest switches between both) -->
        <div class="ipm-dsi-offer" [class.in]="step >= 4">
            <div class="ipm-dsi-ocard is-buyer" *ngIf="variant !== 'seller'" [class.show]="variant === 'buyer' || !showSellerOffer">
                <span class="ipm-dsi-opre">Up to</span>
                <span class="ipm-dsi-on">50%</span>
                <span class="ipm-dsi-ow">Off</span>
                <span class="ipm-dsi-ol">On beats</span>
            </div>
            <div class="ipm-dsi-ocard is-seller" *ngIf="variant !== 'buyer'" [class.show]="variant === 'seller' || showSellerOffer">
                <span class="ipm-dsi-on">45%</span>
                <span class="ipm-dsi-ow">Off</span>
                <span class="ipm-dsi-ol">On Pro Annual Plan</span>
            </div>
        </div>

        <div class="ipm-dsi-live" [class.in]="step >= 5">Sale is Live Now</div>

        <button type="button" class="ipm-dsi-cta" [class.in]="step >= 6" (click)="close()">Explore Diwali Deals →</button>
    </div>

    <button type="button" class="ipm-dsi-skip" [class.in]="step >= 1" (click)="close()">Skip</button>
</div>
